import { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Card, Text, Button } from '@bancobarigui/barihaus';

import { inspectionAssignmentService } from '@/services/inspectionAssignment.service';

interface InspectorAcceptModalProps {
  open: boolean;
  onClose: () => void;
  assignmentId: string;
  onSuccess?: () => void;
}

export function InspectorAcceptModal({
  open,
  onClose,
  assignmentId,
  onSuccess
}: InspectorAcceptModalProps) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values: { notes?: string }) => {
    setSubmitting(true);
    try {
      await inspectionAssignmentService.inspectorAccept(assignmentId, {
        notes: values.notes || 'Inspeção aceita'
      });

      message.success('Inspeção aceita com sucesso!');
      form.resetFields();
      onSuccess?.();
      onClose();
    } catch {
      message.error('Erro ao aceitar inspeção');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <CheckCircleOutlined className="text-green-500" />
          <Text strong>Aceitar Inspeção</Text>
        </div>
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <div className="py-4">
        <Card className="mb-6 bg-green-50 border-green-200">
          <div className="flex items-start gap-3">
            <CheckCircleOutlined className="text-green-500 mt-1" />
            <div>
              <Text strong className="text-green-900 block mb-1">
                Confirmar Aceitação da Inspeção
              </Text>
              <Text className="text-green-700 text-sm">
                Ao aceitar esta inspeção, você confirma sua disponibilidade para realizá-la. 
                Você pode adicionar observações sobre sua aceitação.
              </Text>
            </div>
          </div>
        </Card>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="notes"
            label="Observações (opcional)"
            extra="Adicione informações sobre sua aceitação da inspeção"
          >
            <Input.TextArea
              placeholder="Ex: Confirmo disponibilidade para realizar a inspeção na data solicitada."
              rows={3}
              maxLength={500}
              showCount
            />
          </Form.Item>

          <Form.Item className="mb-0 pt-4">
            <div className="flex gap-3 justify-end">
              <Button
                onClick={handleCancel}
                disabled={submitting}
              >
                Cancelar
              </Button>
              <Button
                buttonColor="primary"
                htmlType="submit"
                loading={submitting}
              >
                Aceitar Inspeção
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}